@if (caseData && !loading()) {
  <div class="wrapper">
    <app-header></app-header>
    <div class="content flex column vcenter">
      @if (windowWidth > 950) {
        <div>
          <div class="flex grow1">
            <div class="grow1">
              <app-details [caseData]="caseData"></app-details>
            </div>
            <div>
              @if (!isCasePaused()) {
                <app-countdown [caseData]="caseData"></app-countdown>
              }
            </div>
          </div>
          <app-claims-list [caseData]="caseData"></app-claims-list>
          <mat-divider></mat-divider>
          <app-deposit
            id="deposit01"
            [caseData]="caseData"
            (toggleClaimsList)="claimsListOpen = !claimsListOpen"
          ></app-deposit>
        </div>
      }
      @if (windowWidth <= 950) {
        <div>
          <app-details [caseData]="caseData"></app-details>
          <mat-divider></mat-divider>
          <app-deposit
            id="deposit02"
            [caseData]="caseData"
            (toggleClaimsList)="claimsListOpen = !claimsListOpen"
          ></app-deposit>
          <mat-divider></mat-divider>
          <app-claims-list [caseData]="caseData"></app-claims-list>
          @if (!isCasePaused()) {
            <app-countdown [caseData]="caseData"></app-countdown>
          }
        </div>
      }
    </div>
    <app-footer></app-footer>
  </div>
}

@if (loading()) {
  <div class="loading-wrapper flex column vcenter hcenter">
    <img
      src="assets/shared/global-images/payee-logos/v1/white-payee-with-badge.svg"
      width="149px"
      alt="Payee"
    />
    <img
      src="assets/Bean Eater-1s-207px.svg"
      height="95px"
      class="loading-animation"
      alt=""
    />
  </div>
}
